import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { getCurrencies, getHistoryPrices } from "../../redux/actions.main";
import TableComponent from "./Table/Table";
import MainModal from "./Modal/MainModal";
import styles from "./Main.module.scss";
import linkedin from "../../assets/linkedin.png";
import email from "../../assets/email.png";

const Main = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { currencies } = useSelector((state) => state.main);
  const { currentPage } = useParams();

  const goToCurrencyPage = (currency) => {
    dispatch(getHistoryPrices(currency.id));
    history.push({
      pathname: `/currency/${currency.id}`,
      state: { currency },
    });
  };

  const currenciesToRender = currencies.map((currency) => (
    <tr
      key={currency.rank}
      className={styles.currency}
      onClick={() => goToCurrencyPage(currency)}
    >
      <td>{currency.rank}</td>
      <td>{currency.symbol}</td>
      <td>{currency.name}</td>
      <td>{+Number(currency.priceUsd).toFixed(2)}$</td>
      <td>{+Number(currency.changePercent24Hr).toFixed(2)}%</td>
      <td onClick={(e) => e.stopPropagation()}>
        <MainModal currency={currency} />
      </td>
    </tr>
  ));

  useEffect(() => {
    dispatch(getCurrencies(+currentPage - 1));
  }, [currentPage, dispatch]);

  return (
    <div>
      <TableComponent
        currenciesToRender={currenciesToRender}
        currentPage={currentPage}
      />
      <div className="contacts__main">
        <p>©Copyright 2023 developed by Artem Nefedov. All Rights are reserved.</p>
        <a href="https://www.linkedin.com/in/alex-nefedov/"><img style={{width: "33px", marginRight: "15px"}} className="contacts__main-img" src={linkedin} alt="linkedin" /></a>
        <a href="mailto:alexnefedovqa@gmail.com"><img style={{width: "50px"}} className="contacts__main-img" src={email} alt="email" /></a>
      </div>
    </div>
  );
};
export default Main;
